// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w18E","index":"styles_index__1mUYP"};